import { FeatureKey } from "@repo/utils";

export const remoteConfigDefaults: Record<string, string | number | boolean> = {
  [FeatureKey.HOME_PAGE]: false,
  [FeatureKey.NEW_DASHBOARD]: false,
  [FeatureKey.ENABLE_CHAT]: false,
  [FeatureKey.USER_VERTICAL]: "learn",
  [FeatureKey.AINA_DISABLE_MIC]: false,
  [FeatureKey.AINA_DISABLE_DOUBTS]: false,
  [FeatureKey.REFERRAL_AWARDS]: JSON.stringify({
    countries: [
      {
        countryCode: "IN",
        isdCode: "+91",
        rewards: [
          {
            icon: "https://firebasestorage.googleapis.com/v0/b/unified-infinity-learn.appspot.com/o/refer_earn%2Frefer_icons%2Fdoubts.png?alt=media&token=dd4ea8db-0748-4599-b01f-6fae63c180f0",
            text: "Win 100 Doubts on Solution App",
            highlight: "100 Doubts",
          },
          {
            icon: "https://firebasestorage.googleapis.com/v0/b/unified-infinity-learn.appspot.com/o/refer_earn%2Frefer_icons%2Fvalidity.png?alt=media&token=0f28b0bf-0ff5-4b37-948a-fb21bb39555d",
            text: "Extend validity by 2 months",
            highlight: "2 months",
          },
          {
            icon: "https://firebasestorage.googleapis.com/v0/b/unified-infinity-learn.appspot.com/o/refer_earn%2Frefer_icons%2Fcupon.png?alt=media&token=67138a5c-0453-4496-aac7-482ab81db2b0",
            text: "Win a ₹35,000 shopping voucher",
            highlight: "₹35,000",
          },
        ],
      },
      {
        countryCode: "AE",
        isdCode: "+971",
        rewards: [
          {
            icon: "https://firebasestorage.googleapis.com/v0/b/unified-infinity-learn.appspot.com/o/refer_earn%2Frefer_icons%2Fdoubts.png?alt=media&token=dd4ea8db-0748-4599-b01f-6fae63c180f0",
            text: "Win 100 Doubts on Solution App",
            highlight: "100 Doubts",
          },
          {
            icon: "https://firebasestorage.googleapis.com/v0/b/unified-infinity-learn.appspot.com/o/refer_earn%2Frefer_icons%2Fvalidity.png?alt=media&token=0f28b0bf-0ff5-4b37-948a-fb21bb39555d",
            text: "Extend validity by 2 months",
            highlight: "2 months",
          },
          {
            icon: "https://firebasestorage.googleapis.com/v0/b/unified-infinity-learn.appspot.com/o/refer_earn%2Frefer_icons%2Fcupon.png?alt=media&token=67138a5c-0453-4496-aac7-482ab81db2b0",
            text: "Win a AED 1,500 shopping voucher'",
            highlight: "AED 1,500",
          },
        ],
      },
      {
        countryCode: "US",
        isdCode: "+1",
        rewards: [
          {
            icon: "https://firebasestorage.googleapis.com/v0/b/unified-infinity-learn.appspot.com/o/refer_earn%2Frefer_icons%2Fdoubts.png?alt=media&token=dd4ea8db-0748-4599-b01f-6fae63c180f0",
            text: "Win 100 Doubts on Solution App",
            highlight: "100 Doubts",
          },
          {
            icon: "https://firebasestorage.googleapis.com/v0/b/unified-infinity-learn.appspot.com/o/refer_earn%2Frefer_icons%2Fvalidity.png?alt=media&token=0f28b0bf-0ff5-4b37-948a-fb21bb39555d",
            text: "Extend validity by 2 months",
            highlight: "2 months",
          },
          {
            icon: "https://firebasestorage.googleapis.com/v0/b/unified-infinity-learn.appspot.com/o/refer_earn%2Frefer_icons%2Fcupon.png?alt=media&token=67138a5c-0453-4496-aac7-482ab81db2b0",
            text: "Win a $500 shopping voucher'",
            highlight: "$500",
          },
        ],
      },
    ],
  }),
  [FeatureKey.BRIDGE_COURSE_GRADE_MAPPING]: "{}",
  [FeatureKey.PROGRAM_JOURNEY]: "{}",
};
